export default "__VITE_ASSET__D2p3dJtm__"